import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../Context";

function ParamMonogram() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const [hovered, setHovered] = useState(null);
    const location = [
        { text: "Cuff", value: "cuff" },
        { text: "Body", value: "body" },
        { text: "Pocket/Chest", value: "pocket" },
        { text: "Bottom Plackt", value: "placket" },
        { text: "Inner Collar", value: "collarIn" },
        { text: "Outer Collar", value: "collarOut" },
    ];
    const colors = [
        { id: "blue", color: "monogram-blue.png" },
        { id: "lightBlue", color: "monogram-lightBlue.png" },
        { id: "brown", color: "monogram-brown.png" },
        { id: "gold", color: "monogram-gold.png" },
        { id: "white", color: "monogram-white.png" },
        { id: "gray", color: "monogram-gray.png" },
        { id: "black", color: "monogram-black.png" },
        { id: "navy", color: "monogram-navy.png" },
        { id: "green", color: "monogram-green.png" },
        { id: "red", color: "monogram-red.png" },
        { id: "burgundy", color: "monogram-burgundy.png" },
        { id: "lavender", color: "monogram-lavender.png" },
        { id: "lightPink", color: "monogram-lightPink.png" },
        { id: "pink", color: "monogram-pink.png" },
        { id: "orange", color: "monogram-orange.png" },
        { id: "purple", color: "monogram-purple.png" }
    ];
    const txt1 = useRef(null);
    const txt2 = useRef(null);
    const txt3 = useRef(null);

    function onClick(e) {
        e.target.select();
    }

    function onLocationChanged(location) {
        dispatch({ type: "SET_MONOGRAM", payload: true });
        dispatch({ type: "SET_MONOGRAM_LOCATION", payload: location });
        dispatch({ type: "SET_MONOGRAM_PRICE", payload: 5 });
    }

    function autoFocus(currentRef, nextRef) {
        const value = currentRef.current.value.toUpperCase();
        if (/^[A-Z]$/.test(value)) {
            currentRef.current.value = value;
            if (nextRef) {
                nextRef.current.focus();
                nextRef.current.select();
            }
            updateMonoText();
        } else {
            currentRef.current.value = "";
            updateMonoText();
        }
    }

    function updateMonoText() {
        const t1 = txt1.current.value || "";
        const t2 = txt2.current.value || "";
        const t3 = txt3.current.value || "";
        dispatch({ type: "SET_MONOGRAM", payload: true });
        dispatch({ type: "SET_MONOGRAM_TEXT", payload: t1 + t2 + t3 });
        dispatch({ type: "SET_MONOGRAM_PRICE", payload: 5 });
    }

    function fontStyle(style) {
        dispatch({ type: "SET_MONOGRAM", payload: true });
        dispatch({ type: "SET_MONOGRAM_FONT_STYLE", payload: style });
        dispatch({ type: "SET_MONOGRAM_PRICE", payload: 5 });
    }

    function onColorClick(color) {
        dispatch({ type: "SET_MONOGRAM", payload: true });
        dispatch({ type: "SET_MONOGRAM_COLOR", payload: color });
        dispatch({ type: "SET_MONOGRAM_PRICE", payload: 5 });
    }

    function removeColor() {
        dispatch({ type: "SET_MONOGRAM", payload: false });
        dispatch({ type: "SET_MONOGRAM_PRICE", payload: 0 });
        dispatch({ type: "SET_DONE", payload: true });
    }
    return (
        <div className="paramItem">
            <div className="paramHeader" style={{ borderBlock: "none" }}>
                <div className="paramTitle" style={{ paddingBottom: 0 }}>
                    Monogram
                </div>
                <div className="paramPrice">+$5</div>
                <div className="monoRow">
                    <div className="monoLabel">Text</div>
                    <div className="monoInputs">
                        <input
                            ref={txt1}
                            type="text"
                            className="monoInput"
                            maxLength={1}
                            value={state.monogramText?.[0] || ""}
                            onClick={onClick}
                            onInput={() => autoFocus(txt1, txt2)}
                        />
                        <input
                            ref={txt2}
                            type="text"
                            className="monoInput"
                            maxLength={1}
                            value={state.monogramText?.[1] || ""}
                            onClick={onClick}
                            onInput={() => autoFocus(txt2, txt3)}
                        />
                        <input
                            ref={txt3}
                            type="text"
                            className="monoInput"
                            maxLength={1}
                            value={state.monogramText?.[2] || ""}
                            onClick={onClick}
                            onInput={() => autoFocus(txt3, null)}
                        />
                    </div>
                </div>
                <div className="monoRow">
                    <div className="monoLabel">Location</div>
                    <select
                        className="monoLocation"
                        value={state.monogramLocation}
                        onChange={(e) => onLocationChanged(e.target.value)}
                    >
                        {location.map((loc) => (
                            <option key={loc.value} value={loc.value}>
                                {loc.text}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="monoRow">
                    <div className="monoLabel">Style</div>
                    <div className="monoStyleBox">


                        <img
                            onClick={() => fontStyle("style2")}
                            onMouseEnter={() => setHovered("style2")}
                            onMouseLeave={() => setHovered(null)}
                            className="monoStyleImage"
                            src={`${process.env.PUBLIC_URL}/images/${state.monogramFontStyle === "style2"
                                ? "style2On"
                                : hovered === "style2"
                                    ? "style2Hover"
                                    : "style2"
                                }.svg`}
                            alt=""
                        />
                        <img
                            onClick={() => fontStyle("style1")}
                            onMouseEnter={() => setHovered("style1")}
                            onMouseLeave={() => setHovered(null)}
                            className="monoStyleImage"
                            src={`${process.env.PUBLIC_URL}/images/${state.monogramFontStyle === "style1"
                                ? "style1On"
                                : hovered === "style1"
                                    ? "style1Hover"
                                    : "style1"
                                }.svg`}
                            alt=""
                        />
                    </div>
                </div>
                <div className="monoRow">
                    <div className="monoLabel">Color</div>
                </div>
            </div>
            <div className="monoList" style={{ marginTop: "-15px" }}>
                {colors.map((color) => (
                    <div key={color.id} className="monoBtnColor">
                        <img
                            onClick={() => onColorClick(color.id)}
                            className="monoImgColor"
                            src={`${process.env.PUBLIC_URL}/images/${color.color}`}
                            width={80}
                            alt={color.id}
                        />

                        <div className="monoColorName">{color.id}</div>
                        {(state.monogramColor === color.id && state.monogram) && (
                            <img
                                className="tickWhite"
                                src={process.env.PUBLIC_URL + "/images/tickWhite.svg"}
                                alt="selected"
                            />
                        )}
                    </div>
                ))}
            </div>
            <div style={{ display: "flex", justifyContent: "center", padding: "14px", height: "60px", alignItems: "center" }}>
                <div onClick={removeColor} className="paramButtons">Remove</div>
            </div>
        </div>
    );
}
export default ParamMonogram;
